import { path } from "../../config";
import { store } from "../../redux/store";
import fetchServer from "../fetchServer";

export async function addBookingsData(data,userId) {
  var result = {return: 0,msg: 'Error',data: {}}

  let token = store.getState().user.userData.accessToken;

  console.log(" --- on Multi Booking Data ---")
  console.log("userId - ",userId)
  console.log("data - ",data)
  console.log(" --------- -----------")

  await fetchServer({method: "POST",url: path.api+'/users/multiple-booking-data/',data,
    headers: {
      Authorization: `Bearer ${token}`,
      'user-id': userId
    }
  })
  .then((res) => {
    console.log(" => ",res)
    if(res) {
      if(res?.data?.success) {
        result = {return: 1,msg: "Successfull",data: res.data.data};
      } else if(res?.error) result['msg'] = res?.error?.message;
    } 
  })
  .catch((err) => {
    console.log("Network Error: ",err);
  })

  return result;

}